import React from "react";
import { IExpand } from "../../../../types/expand.type";
import WrapperExpand from "../WrapperExpand";
import { Box, Button, Grid2, Stack } from "@mui/material";
import { asyncDelete } from "../../../../utils/httpRequests";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import TextInput from "../../input/TextInput";
import ImageGallery from "../../imageGallery/ImageGallery";
import { generateLinkImage } from "../../../../utils/helpers";
import ModalReplyComplaint from "../../modal/ModalReplyComplaint";

function ExpandComplaint({ data, onOpenEdit, setLoad }: IExpand) {
  const { token, profile } = useSelector((state: any) => state.auth);
  const { showAlert } = useAlertContext();

  const handleDelete = async () => {
    const resp = await asyncDelete({
      apiCode: "socialcomment",
      id: data?._id,
      token,
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi xóa dữ liệu",
      });
    } else {
      showAlert({ type: "success", message: `Đã xóa thành công` });
      setLoad?.((prev) => prev + 1);
    }
  };

  return (
    <WrapperExpand
      data={data}
      sx={{ py: 0 }}
      action={
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
          sx={{ py: 1 }}
        >
          <ModalReplyComplaint data={data} />
          {profile?.admin_app && (
            <Button
              onClick={onOpenEdit}
              variant="contained"
              size="small"
              sx={{
                boxShadow: "none",
                textTransform: "none",
                color: "common.white",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Chỉnh sửa
            </Button>
          )}
          {profile?.admin_app && (
            <Button
              onClick={() => {
                showAlert({
                  title: "Xác nhận xóa",
                  type: "info",
                  message: "Bạn có chắc muốn xóa dòng này không ?",
                  onConfirm: handleDelete,
                });
              }}
              variant="contained"
              size="small"
              color="error"
              sx={{
                boxShadow: "none",
                textTransform: "none",
                color: "common.white",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Xóa
            </Button>
          )}
        </Stack>
      }
    >
      <Box sx={{ p: 1 }}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 6 }}>
            <TextInput
              readOnly
              label="Loại liên hệ"
              value={data?.of_name}
              onChange={() => {}}
            />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <TextInput
              readOnly
              multiline
              label="Nội dung"
              value={data?.content}
              onChange={() => {}}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            {/* Hinh anh */}
            {data?.attends?.length > 0 && (
              <Box
                sx={{
                  p: 1,
                  borderRadius: "10px",
                }}
              >
                <ImageGallery
                  maxItem={3}
                  items={(data?.attends || []).map((item: any) =>
                    generateLinkImage(item.fileUrl)
                  )}
                />
              </Box>
            )}
          </Grid2>
        </Grid2>
      </Box>
    </WrapperExpand>
  );
}

export default ExpandComplaint;
